import api from '@pray/shared/utils/api';

export type EmailHealthMetrics = {
  delivery_rate: number;
  bounce_rate: number;
  spam_rate: number;
  open_rate: number;
  click_rate: number;
  gmail_spam_rate: number | null;
};

export type EmailHealthVolume = {
  sent: number;
  delivered: number;
  bounced: number;
  spam: number;
};

export type EmailHealthOverviewResponse = {
  health_score: {
    score: number;
    level: 'healthy' | 'warning' | 'danger';
  };
  metrics: EmailHealthMetrics;
  volume: EmailHealthVolume;
  daily_stats: Array<{ date: string; metrics: EmailHealthMetrics }>;
  gmail_spam_rate: number | null;
};

export type GetEmailHealthOverviewParams = {
  start_date: string;
  end_date: string;
};

export async function getEmailHealthOverview({
  start_date,
  end_date,
}: GetEmailHealthOverviewParams): Promise<EmailHealthOverviewResponse> {
  const params: Record<string, string> = { start_date, end_date };

  const url = '/web/studio/system-check/email-health/overview';
  const response = await api.executeGetRequest<{ data: EmailHealthOverviewResponse }>(url, params);

  return response.data.data;
}
